<div class="sx-help-glossary">
  <div class="sx-help-glossary__search">
    <mat-form-field class="sxh-full-width" appearance="outline">
      <input matInput placeholder="Sök" (input)="doSearch($event.target.value)" id="field_glossary_search">
      <button matSuffix class="sx-button-suffix sx-button-stripped">
        <svg>
          <use xlink:href="#baseline-search-24px" href="#baseline-search-24px" />
        </svg>
      </button>
    </mat-form-field>
  </div>

  <div *ngFor="let word of glossaryDisplay; index as i">
    <div class="sx-help-glossary__section-title" *ngIf="i === 0 || glossaryDisplay[i-1].term[0] !== word.term[0]" id="letter_{{word.term[0]}}">
      {{ word.term[0].toUpperCase() }}
    </div>

    <mat-expansion-panel class="sx-help-glossary__expansion-panel">
      <mat-expansion-panel-header>
        <mat-panel-title class="sx-help-glossary__term__title" id="word_{{i}}">
          {{ word.term }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div *ngIf="word.description" class="sx-help-glossary__term__description" [innerHtml]="word.description | safeHtml" id="word_content_{{i}}" appRouterLink>
      </div>

    </mat-expansion-panel>
  </div>
</div>
